import { DetailedHTMLProps, HTMLAttributes, ElementType, FC } from 'react'

interface IIconProps extends DetailedHTMLProps<HTMLAttributes<HTMLElement>, HTMLElement> {
  size?: number
  color?: string
  gradientStart?: string
  gradientMid?: string
  gradientStop?: string
  hasOutline?: boolean
  outlineColor?: string
  colorMatrix?: string
  pathClassName?: string
  innerIconOpacity?: number
  innerIconColor?: string
  icon: ElementType
}

const SVGIcon: FC<IIconProps> = (props) => {
  const { size, color, icon, style: styleArg, ...svgProps } = props
  const svgExtraProps: any = {}
  svgExtraProps['data-icon'] = 'svg'

  if (size !== undefined) {
    svgExtraProps.width = size
    svgExtraProps.height = size
  } else {
    // default
    svgExtraProps.width = '24'
    svgExtraProps.height = '24'
  }

  if (color !== undefined || styleArg !== undefined) {
    svgExtraProps.style = { color, ...styleArg }
  }
  const IconComp: ElementType = icon
  return <IconComp {...svgProps} {...svgExtraProps} />
}

export default SVGIcon
